<template>
  <div class="history-management-view">
    <div class="documentmanagement-header">Document Uploads</div>
    <div class="subsidiary-container">
      <div class="subsidiary-content">
        <div class="sub-header relative" >
          <div class="flex gap-10px items-center">
            <h4 class="subsidiary-title">Upload History</h4>
            <!-- <img src="@/assets/filter.svg" v-if="!filterActive && !showItemsChanges" class="pointer" @click="showFilter()"> -->
            <!-- <img src="@/assets/filter-active.svg" v-else-if="filterActive && !showItemsChanges" class="pointer" @click="showFilter()"> -->
          </div>
          <div v-if="filterStatus" class="cover-elem"></div>
          <div class="filter-area" v-if="filterStatus">
              <div class="cross" @click="filterStatus = false">
                  <img src="@/assets/cross.svg" alt="cross"/>
              </div>
              <h4 class="subsidiary-title">Filters:</h4>
              <div class="filters-list flex gap-20 row wrap">
                  <div class="review-data flex gap-5px">
                      <!-- <InpComponent
                          class="input-el country-select flex-1 w-200"
                          label="Review Date Present"
                          type="options"
                          :options="[{value: '', text: 'All'}, {value: 'yes', text: 'Yes'}, {value: 'no', text: 'No'}]"
                          :key_ref="'review_date_present'"
                          :value="filters.review_date_present"
                          @inputChange="filterInputChange"
                      /> -->
                  </div>
                  <div class="review-data flex gap-5px">
                    <InpComponent
                      v-if="filters.added_at != 'no'"
                      class="input-el country-select  w-content"
                      label="Upload Date After"
                      type="date"
                      placeholder=""
                      :key_ref="'uploaded_at_start'"
                      :value="filters.uploaded_at_start"
                      @inputChange="filterInputChange"
                    />
                    <InpComponent
                      v-if="filters.added_at != 'no'"
                      class="input-el country-select flex-1 w-content"
                      type="date"
                      label="Upload Date Before"
                      placeholder="Client Type"
                      :key_ref="'uploaded_at_end'"
                      :value="filters.uploaded_at_end"
                      @inputChange="filterInputChange"
                    />
                  </div>
              </div> 
              <div class=" w-full mt-20 flex row gap-10">
                  <div class="stick-right"></div>
                  <button class="w-content" v-if="filterActive" @click="clearFilter()">Clear</button>
                  <button class="w-content" @click="applyFilter()">Apply</button>
              </div>
          </div>
        </div>
        <table class="subsidiary-list">
          <thead>
            <tr>
              <th>File name</th>
              <th>Template</th>
              <th>Upload Date</th>
              <th>Rows</th>
              <th class="flex justify-end">Action</th>
            </tr>
          </thead>
          <tbody v-if="fileList">
            <tr class="account-list" v-for="(file, index) in fileList">
              <td >
                <div class='attachment' @click="downloadFile(file.serverName, {'name': file.filename}, true)">
                  <img src="@/assets/excel-file.svg" class='fileicon'>
                  <div class="filename">
                    <div class="name-of-the-file">{{ file.filename }}</div>
                    <div class="size-of-the-file">{{ Utils.calculateFileSize(file.filesize) }}</div>
                  </div>
                </div>
              </td>
              <td class=""> 
                <div class="flex gap-10 justify-start">
                  {{ file.template_label }}
                </div>
              </td>
              <td class="user-info">
                <div class="user-name">
                  {{ formatDate(file.uploadDate) }}
                </div>
              </td>
              <td>{{ file.rows }}</td>
              <td>   
                <div class="flex gap-10 justify-end">
                  <div v-if="((!file.errorList) || (file.errorList && JSON.parse(file.errorList).length == 0)) && file.rows > 0"
                    class="icon-wrapper"
                    @click.stop="downloadFile(file.serverName, {'name': file.filename})">
                    <img 
                      title="Download File"
                      src="@/assets/download.svg" class='icon download' >
                  </div>
                  <div v-if="file.conversionInfo" @click="viewFile(file)" class="icon-wrapper">
                    <img title="View Data" src="@/assets/password-look.svg" class='icon' />
                  </div>

                 
                  <button 
                    v-if="(
                      file.rows > 0
                      && account_id
                      && user.is_super_user 
                      && file.excluded_from_invoicing != true)
                      && ((!file.errorList) || (file.errorList && JSON.parse(file.errorList).length == 0)
                    )"
                    class='w-content' @click="setConfirm(file)">
                      Remove from Invoice
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class='no-data-present no-data-presents' v-if="fileList && fileList.length == 0">
          Nothing here yet
        </div>
      </div>
    </div>
    <vue-awesome-paginate
        v-if="totalFilesCount > 10"
        class="pagination"
        :total-items="totalFilesCount"
        :items-per-page="10"
        :max-pages-shown="8"
        v-model="currentPage"
        @click="handlePageClick"
    />
    <ExcelPreviewTable v-if="previewData" 
      :previewData="previewData" 
      :errorList="errorList"
      :simplified="true"
      @close="() => previewData = null"
    />
    <PopupCover v-if="confirmRemove" @close="confirmRemove = false">
      <PopupBody style="width: 400px;" @close="confirmRemove = false">
        <template #header>
          Confirm Removal
        </template>
        <template #body>
          Are you sure you want to remove this file from the invoice?
          <div class="flex gap-10px justify-end mt-20px mt-auto">
            <button class='w-content' @click="confirmRemove = false">Cancel</button>
            <button class='w-content' @click="removeFile()">Confirm</button>
          </div>
        </template>
      </PopupBody>
    </PopupCover>
  </div>

  </template>
  
<script setup>

  import API from '@/api/index.js'
  import BO_API from '@/api/bo_api.js'
  
  import Utils from '@/utils';
  import PopupBody from '@/components/PopupBody.vue';
  import PopupCover from '@/components/PopupCover.vue';
  import ExcelPreviewTable from '@/components/ExcelPreviewTable.vue';
  import InpComponent from '@/components/InpComponent.vue';
  import { ref, onMounted, computed } from 'vue';
  import store from '../store';

  const fileList = computed(() => store.state.fileList);
  const totalFilesCount = computed(() => store.state.totalFilesCount);
  const currentPage = ref(1);
  const props = defineProps(['account_id'])

  const user = computed(() => store.state.user);
  const confirmRemove = ref(false);

  const filters = ref({});

  const filterActive = ref(false);
  const filterStatus = ref(false);

  onMounted(async () => {
    document.title = 'Uploads';
    await doRequest();
  })


  function filterInputChange(event){
    filters.value[event[0]] = event[1];
    if (!event[1]) {
      delete filters.value[event[0]];
    }
  }
  function showFilter() {
    filterStatus.value = !filterStatus.value;
  }
  function clearFilter() {
    filters.value = {};
    filterStatus.value = false;
    doRequest();
  }
  async function applyFilter(){
    await doRequest();
    filterStatus.value = false;
  }


  const previewData = ref(null);
  const errorList = ref(null);
  function formatDate(date) {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options);
  }
 
  function viewFile(file) {
    try {
      previewData.value = JSON.parse(file.conversionInfo);
      errorList.value = file.errorList ? JSON.parse(file.errorList) : null;
    } catch (e) {
      store.dispatch('addNotification', {text: `Error parsing file data: ${e.message}`, type: 'error'});
    }
  }

  function downloadFile(serverName, filename, original = false) {
    store.dispatch('addNotification', {text: `Your file ${filename.name} is being downloaded`, type: 'success'});
    API.downloadFile(serverName, filename, original);
  }
 
  function setConfirm(file) {
    confirmRemove.value = file;
  }

  const handlePageClick = async (page) => {
    currentPage.value = page;
    await doRequest();
  }
  async function doRequest(){
    await API.getFilesList(props.account_id, currentPage.value);
  }

  async function removeFile() {
    console.log('confirmRemove', confirmRemove.value)
    await BO_API.removeFile(confirmRemove.value.id);
    confirmRemove.value = false;

  }
</script>
  
  
  
  <style scoped lang="scss">



  h4 {
    margin: 0;
  }

  .subsidiary-content {
    min-width: 100%;
    border: 1px solid #ccc;
    border-radius: 10px;
    width: fit-content;
  }
  .documentmanagement-header {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: left;
    color: black;
  }
  .history-management-view {
    display: flex;
    padding: 20px;
    flex-direction: column;
    max-width: 1350px;
    margin: auto;
  }
  .subsidiary-container {
        width: 100%;
    }
    
    .subsidiary-content {
        min-width: 100%;
        border: 1px solid #ccc;
        border-radius: 10px;
        width: fit-content;
    }
    
    .sub-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        padding: 20px;
        padding-left: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
    }
    
    .subsidiary-title {
        display: flex;
        justify-content: space-between;
        color: black;
        font-size: 20px;
    }
    
    .sub-header {
        display: flex;
        justify-content: space-between;
        button {
            width: fit-content;
            padding: 10px;
        }
    }
    .subsidiary-list {
        padding: 20px;
        width: 100%;
        border-collapse: collapse;
        position: relative;
        th, td {
            // border: 1px solid #ccc;
            padding: 15px;
            text-align: left;
            border: none;
            color: black;
        }
        td {
            padding-top: 0px;
            padding-bottom: 0px;
        }
        th {
            text-align: left;
            border: none;
        }
        tr {
            border-top: 1px solid #ccc;
        }
        tbody {
            tr {
                cursor: pointer;
                td {
                    background: white;
                }

                &:last-child {
                    td {
                        &:first-child {
                            border-bottom-left-radius: 10px;
                        }
                        &:last-child {
                            border-bottom-right-radius: 10px;
                        }
                    }
                }
                &:hover {
                    td {
                        background: #f9f9f9;
                    }
                }
            }
        }
    }
    
    .error-button {
        background: #f04f4f;
        color: black;
        border: 1px solid #ffcccc;
    }
    .error-container {
  height: 50vh;
  background-color: #f8d7da; /* Light red background color */
  color: #721c24; /* Dark red text color */
  border: 1px solid #f5c6cb; /* Border color */
  padding: 15px;
  overflow-y: auto;
  margin: 10px 0;
  border-radius: 5px;
  text-align: left;
}
.error-message {
  font-weight: bold;
}
.error-header {
  margin-top: 0;
}

.message-attachments {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.size-of-the-file {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
.details {
    :deep(p) {
        margin: 0;
    }
}
.name-of-the-file {
    display: flex;
    align-items: center;
    color: black;
    font-size: 1rem;

    text-align: left;
    overflow: hidden;
    //text-wrap: nowrap;
    text-overflow: ellipsis;
}
.fileicon {
    width: 40px;
    height: 40px;
}
.hoverable {
    cursor: pointer;
    text-decoration: underline;
    &:hover {
        text-decoration: none;
    }
}

.attachment {
    border-radius: .5rem;
    border-width: 1px;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    padding: .8rem;
    display: flex;
    align-items: center;
    padding-left: 0;
}

.pagination[class] {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  &:deep(button) {
    padding: 10px 20px;
  }
  &:deep(.active-page) {
    // background-color: var(--button-hover-color-blue);
    background: #00408985;
    color: white;
  }
}


.filters-list {
    padding-top: 20px;

    .input-el {
        margin-bottom: 0;
    }
}
.stick-right {
    margin-left: auto;
}
.cover-elem {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  width: 100%;
  height: 100%;
}
.filter-area {
  padding: 15px 30px;
  box-sizing: border-box;
  position: absolute;
  top: 60px;
  left: 1px;
  right: 1px;
  min-height: 180px;
  height: fit-content;
  background-color: white;
  z-index: 10000;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #ccc;
}
.cross {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #e6e6e6;
  }
}
.icon  {
  width: 20px;
  height: 20px;
}

.download {
  width: 15px;
  height: 15px;
}


</style>